import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "./styles/Main.sass";
import Nav from "./views/Nav";
import Admin from "./views/pages/Admin";
import ASC from "./views/pages/ASC";
import Editor from "./views/pages/Editor";
import Map from "./views/pages/Map";
import Protected from "./routes/protected";
import Secured from "./routes/secured";
import { EditSecured } from "./routes/editSecured";
import { ApiContext } from "./context/ApiContext";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider, useCookies } from "react-cookie";
import { apiCall, getUser } from "../src/action";
import { connect } from "react-redux";
import Axios from "./api/api";

function App({ api, getData }) {
  const [user, setUser] = useState([[1, 2]]);
  const [apiData, setApiData] = useState("");
  const [admin, setAdmin] = useState("");
  const [cookies] = useCookies(["isLoggedinASC", "AscID"]);

  // useEffect(() => {
  //   const loggedInUser = window.localStorage.getItem("user");
  //   if (loggedInUser) {
  //     getData(foundUser.user);
  //   }
  // }, []);

  return (
    <BrowserRouter>
      <Route exact path="/" component={Nav} />
      <Route exact path="/admin" component={Admin} />
      <Route exact path="/asc" component={ASC} />
      <Route exact path="/editor" component={Editor} />
      <Route exact path="/map" component={Map} />
    </BrowserRouter>
  );
}
const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps, { getData: getUser, api: apiCall })(
  App
);
